import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash'

class RoomEditor extends Component {

    _change({ target }) {
        this.props.dispatch({ type: 'CHANGE_360_IFRAME', appartmentId: this.props.appartmentId, roomId: this.props.roomId, newValue: target.value })
    }

    _blur({ target }) {
        this.props.dispatch({ type: 'SAVE_APPARTMENT', appartmentId: this.props.appartmentId })
    }

    render() {
        const { cognito, room } = this.props

        return cognito.user ? (
            <div className="room-editor">
                <label>Iframe URL : </label>
                <input type="text" className="editIframeUrl" value={room.IframeUrl} onChange={this._change.bind(this)} onBlur={this._blur.bind(this)} />
            </div>
        ) : null
    }

}

export default connect(
    ({ cognito, app }, { appartmentId, roomId }) => {
        let appartmentIndex = _.findIndex(app.appartments, { Id: appartmentId });
        let roomIndex = _.findIndex(app.appartments[appartmentIndex].Rooms, { Id: roomId });

        const room = app.appartments[appartmentIndex].Rooms[roomIndex]

        console.log(room)

        return {
            room,
            cognito,
            app
        }
    }
)(RoomEditor);



// WEBPACK FOOTER //
// ./src/components/360Mode/AppartmentView/RoomEditor.js